<template>
    <div class="news-wrapper">
      <app-header-mini :img="'/static/img/news/header.jpg'" :texts="headerTexts"></app-header-mini>
      <div class="news-latest">
        <img class="circle-1" src="/static/img/news/circle.svg" alt="">
        <div class="news-container">
          <router-link v-for="item in latestNews" :to="`/news/${item.url}`" :key="`latest-${item.url}`" class="news-main" :style="{backgroundImage: `url(//alcomet.eu/uploads/news/${item.cover})`}">
              <div class="news-footer">
                  <span>{{item.date | formatDate}}</span>
                  <h6>{{item.content.it.title}}</h6>
              </div>
          </router-link>
        </div>
      </div>
      <h2 v-if="!showMediaNews" class="category-title">Ultime notizie</h2>
      <h2 v-if="showMediaNews" class="category-title">Cosa dicono di noi</h2>
      <div class="news-all-wrapper">
        <div class="aside" ref="newsAside" :class="{ 'aside-opened': isMenuOpened }">
          <p class="news-mobile-main-item" :class="{ 'news-mobile-main-item-active' : isMenuOpened }" @click="toggleMenu()">Seleziona notizie</p>
            <ul class="aside-ul">
              <li class="aside-li" :class="{ 'aside-li-active': isMenuOpened }">
                  <a class="aside-item" :class="{ 'aside-item-active' : !showMediaNews }" @click="itemSelected(false)">
                    Ultime notizie
                  </a>
              </li>
              <li class="aside-li" :class="{ 'aside-li-active': isMenuOpened }">
                  <a class="aside-item" :class="{ 'aside-item-active' : showMediaNews }" @click="itemSelected(true)">
                    Cosa dicono di noi
                  </a>
              </li>
            </ul>
        </div>
        <div class="news-all-content" ref="allNewsContainer">
          <img class="circle-2" src="/static/img/news/circle.svg" alt="">
          <router-link class="news-all-item" v-for="currentNews in news" :key="currentNews.url" :to="`/news/${currentNews.url}`" v-if="currentNews.isMediaNews === showMediaNews">
            <div class="news-all-item-img" :style="{ backgroundImage : `url(https://alcomet.eu/uploads/news/${currentNews.cover})`}"></div>
            <div class="news-all-item-texts">
              <h4 class="news-all-item-title">{{currentNews.content.it.title}}</h4>
              <p class="news-all-item-content" v-html="currentNews.content.it.contentOne.substr(0, 120)"></p>
              <p class="news-all-item-date">{{currentNews.date | formatDate}}</p>
            </div>
          </router-link>
        </div>
      </div>
    </div>
</template>

<script>
import HeaderMini from "./shared/HeaderMini";
import Aside from "./shared/Aside";
export default {
  components: {
    appHeaderMini: HeaderMini,
    appAside: Aside
  },
  data() {
    return {
      headerTexts: ["Notizie"],
      showMediaNews: false,
      isMenuOpened: false,
      news: [],
      latestNews: []
    };
  },
  methods: {
    openNews() {},
    toggleMenu() {
      this.isMenuOpened = this.isMenuOpened === false ? true : false;
    },
    itemSelected(boolean) {
      this.showMediaNews = boolean;
      if (window.innerWidth < 1000) {
        // for mobile
        window.scrollTo({
          top: this.$refs.allNewsContainer.offsetTop - 90,
          behavior: "smooth"
        });
      } else {
        // for desktop
        window.scrollTo({
          top: this.$refs.newsAside.offsetTop - 100,
          behavior: "smooth"
        });
      }
      this.isMenuOpened = false;
    },
    checkForMedias() {
      if (this.$route.query.medias === "true") {
        this.showMediaNews = true;
      } else {
        this.showMediaNews = false;
      }
    },
    getLatestNews() {
      this.latestNews = [];
      this.$http
        .get(`${process.env.ROOT_API}/news/latest`)
        .then(response => {
          response.data.news.forEach(item => {
            this.latestNews.push(item);
          });
        })
        .catch(error => {
          // handle error
          console.log(error);
        })
        .then(() => {
          // always executed
        });
    },
    getNews() {
      this.news = [];
      this.$http
        .get(`${process.env.ROOT_API}/news`)
        .then(response => {
          response.data.news.forEach(item => {
            this.news.push(item);
          });
        })
        .catch(error => {
          // handle error
          console.log(error);
        })
        .then(() => {
          // always executed
        });
    }
  },
  watch: {
    "$route.query"(to, from) {
      this.checkForMedias();
    }
  },
  mounted() {
    this.checkForMedias();
    this.getLatestNews();
    this.getNews();
  }
};
</script>

<style scoped>
.news-latest {
  background-image: url("/static/img/news/latest_bg.jpg");
  background-size: cover;
  display: flex;
  justify-content: flex-end;
  padding: 40px 40px 60px;
  position: relative;
}
.circle-1,
.circle-2 {
  height: 110vh;
  left: -55vh;
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  width: 110vh;
  z-index: 2;
}
.circle-2 {
  top: 0;
  left: initial;
  right: -55vh;
  transform: initial;
  z-index: -1;
}
h1 {
  color: #004787;
  font-size: 36px;
  font-weight: 300;
  margin: 50px 0;
}
.news-container {
  display: flex;
  height: 485px;
  width: 90%;
  margin: 0 40px;
  position: relative;
  z-index: 3;
}
.news-main {
  background-color: #fff;
  background-size: cover;
  background-position: 50% 50%;
  border-radius: 5px;
  -webkit-box-shadow: 0px 17px 41px 0px rgba(51, 58, 69, 0.36);
  -moz-box-shadow: 0px 17px 41px 0px rgba(51, 58, 69, 0.36);
  box-shadow: 0px 17px 41px 0px rgba(51, 58, 69, 0.36);
  cursor: pointer;
  height: 100%;
  margin-left: 5%;
  position: relative;
  -webkit-transition: all 0.6s cubic-bezier(0.075, 0.82, 0.165, 1);
  -moz-transition: all 0.6s cubic-bezier(0.075, 0.82, 0.165, 1);
  -ms-transition: all 0.6s cubic-bezier(0.075, 0.82, 0.165, 1);
  -o-transition: all 0.6s cubic-bezier(0.075, 0.82, 0.165, 1);
  transition: all 0.6s cubic-bezier(0.075, 0.82, 0.165, 1);
  width: 28.33%;
}
.news-main::before {
  align-items: center;
  border-radius: 50%;
  background-color: rgba(44, 125, 206, 0.89);
  -webkit-box-shadow: 0px 8px 17px 0px rgba(44, 125, 206, 0.32);
  -moz-box-shadow: 0px 8px 17px 0px rgba(44, 125, 206, 0.32);
  box-shadow: 0px 8px 17px 0px rgba(44, 125, 206, 0.32);
  color: #fff;
  content: "c";
  font-family: "alcomet";
  font-size: 22px;
  display: flex;
  height: 60px;
  justify-content: center;
  left: -30px;
  position: absolute;
  top: 8%;
  width: 60px;
}
.news-main:hover {
  transform: translateY(-5px);
}
.news-img {
  border-radius: 6px;
  -o-object-fit: cover;
  object-fit: cover;
  height: 100%;
  width: 100%;
}
.news-footer {
  background: -moz-linear-gradient(
    top,
    rgba(0, 0, 0, 0) 0%,
    rgba(0, 0, 0, 1) 100%
  );
  background: -webkit-linear-gradient(
    top,
    rgba(0, 0, 0, 0) 0%,
    rgba(0, 0, 0, 1) 100%
  );
  background: linear-gradient(
    to bottom,
    rgba(0, 0, 0, 0) 0%,
    rgba(0, 0, 0, 1) 100%
  );
  filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#00000000', endColorstr='#000000',GradientType=0 );
  border-bottom-left-radius: 6px;
  border-bottom-right-radius: 6px;
  bottom: 0;
  padding: 25px;
  position: absolute;
  width: 100%;
}
.news-footer span {
  color: #fff;
  border-radius: 20px;
  display: inline-block;
  font-size: 12px;
  margin-bottom: 10px;
}
.news-footer h6 {
  color: #fff;
  font-size: 18px;
}
/* ALL NEWS */
.news-all-wrapper {
  display: flex;
}
/* ASIDE */
.aside {
  width: 20%;
  padding-top: 15px;
  padding-bottom: 30px;
  position: relative;
  z-index: 3;
}
.aside-ul {
  padding: 10px 0 20px 0;
  border-right: 1px solid #c5d7e4;
}
.aside-li {
  display: block;
  text-align: right;
}
.aside-title {
  color: #00305b;
  display: block;
  font-size: 16px;
  padding: 15px 42px 15px 0;
  text-align: right;
}
.aside-item {
  border-right: 6px solid transparent;
  display: block;
  font-size: 16px;
  text-transform: uppercase;
  height: 100%;
  padding: 11px 36px 11px 0;
}
.aside-item:hover {
  border-right: 6px solid #00305b;
  color: #00305b;
}
.aside-item-active {
  border-right: 6px solid #00305b;
  color: #00305b;
  font-weight: 700;
}
/* NEWS */
.news-all-content {
  align-items: center;
  display: flex;
  flex-direction: column;
  justify-content: center;
  overflow: hidden;
  padding: 20px 40px;
  position: relative;
  width: 80%;
}
/* SINGLE NEWS ITEM */
.news-all-item {
  background-color: rgba(225, 230, 233, 0.5);
  border-radius: 6px;
  -webkit-box-shadow: 10px 10px 250px 0px rgba(0, 0, 0, 0.4);
  -moz-box-shadow: 10px 10px 250px 0px rgba(0, 0, 0, 0.4);
  box-shadow: 10px 10px 250px 0px rgba(0, 0, 0, 0.4);
  cursor: pointer;
  display: flex;
  height: 168px;
  margin: 24px 0;
  -webkit-transition: all 0.2s ease;
  -moz-transition: all 0.2s ease;
  -ms-transition: all 0.2s ease;
  -o-transition: all 0.2s ease;
  transition: all 0.2s ease;
  width: 80%;
}
.news-all-item:hover {
  background-color: rgba(225, 230, 233, 0.2);
}
.news-all-item-img {
  background-size: cover;
  border-radius: 6px;
  height: 100%;
  margin: -13px 0 0 -13px;
  width: 28%;
}
.news-all-item-content {
  width: 100%;
}
.news-all-item-texts {
  align-content: space-around;
  display: flex;
  /* flex-direction: column; */
  flex-wrap: wrap;
  height: 100%;
  padding: 10px 48px;
  width: 72%;
}
.news-all-item-title {
  font-size: 20px;
  font-weight: 500;
}
.news-all-item-date {
  color: rgba(26, 67, 124, 0.7);
  font-size: 12px;
}
.category-title {
  display: none;
}
.news-mobile-main-item {
  display: none;
}
@media screen and (max-width: 1600px) {
  .news-container {
    height: 450px;
  }
}
@media screen and (max-width: 1440px) {
  .news-container {
    height: 400px;
  }
  .news-footer h6 {
    font-size: 18px;
  }
  .news-all-item-img {
    width: 32%;
  }
  .news-all-item-texts {
    width: 68%;
  }
}
@media screen and (max-width: 1366px) {
  .news-container {
    height: 300px;
  }
}
@media screen and (max-width: 1280px) {
  .aside {
    width: 30%;
  }
  .news-all-item {
    width: 95%;
  }
}
@media screen and (max-width: 1000px) {
  .news-all-content {
    overflow: hidden;
    padding: 20px 30px;
    width: 100%;
  }
  .news-latest {
    overflow: hidden;
    padding: 30px;
  }
  .news-container {
    flex-direction: column;
    height: 100vw;
    /* margin: 0;
    width: 100%; */
    z-index: 0;
  }
  .circle-1 {
    z-index: 0;
  }
  .news-main {
    background-position: top;
    margin: 10px 0;
    width: 100%;
  }
  .news-all-item {
    margin: 15px 0;
    width: 100%;
  }
  .news-all-item-title {
    font-size: 16px;
  }
  .news-all-item-content {
    font-size: 13px;
  }
  .category-title {
    display: block;
    font-size: 24px;
    text-align: center;
    position: relative;
    z-index: 2;
  }
  .aside {
    background-color: rgba(0, 71, 133, 0.98);
    border-top-left-radius: 10px;
    border-top-right-radius: 10px;
    border: 2px solid #fff;
    border-bottom: none;
    bottom: 0;
    left: 48px;
    max-height: calc(100vh - 90px);
    min-height: 50px;
    padding: 0;
    position: fixed;
    -webkit-transition: all 0.4s ease;
    -moz-transition: all 0.4s ease;
    -ms-transition: all 0.4s ease;
    -o-transition: all 0.4s ease;
    transition: all 0.4s ease;
    width: calc(100% - 96px);
    z-index: 9;
  }
  .aside::after {
    color: #fff;
    content: "M";
    font-size: 18px;
    font-family: "alcomet";
    height: 20px;
    position: absolute;
    right: 20px;
    top: 15px;
    -webkit-transition: all 0.4s ease;
    -moz-transition: all 0.4s ease;
    -ms-transition: all 0.4s ease;
    -o-transition: all 0.4s ease;
    transition: all 0.4s ease;
    width: 20px;
  }
  .aside-opened {
    z-index: 9;
  }
  .aside-opened::after {
    transform: rotate(-180deg);
  }
  .news-mobile-main-item {
    align-items: center;
    color: #fff;
    font-size: 18px;
    display: flex;
    height: 50px;
    padding: 0 20px;
    position: relative;
    width: 100%;
    z-index: 1;
  }
  .news-mobile-main-item-active {
    display: none;
  }
  .aside-ul {
    border: none;
    max-height: calc(100vh - 140px);
    overflow: auto;
    padding: 0;
  }
  .aside-li {
    height: 0px;
    opacity: 0;
    overflow: hidden;
    -webkit-transition: all 0.4s ease;
    -moz-transition: all 0.4s ease;
    -ms-transition: all 0.4s ease;
    -o-transition: all 0.4s ease;
    transition: all 0.4s ease;
    text-align: left;
  }
  .aside-li-active {
    height: 50px;
    opacity: 1;
  }
  .aside-item {
    align-items: center;
    border: none;
    color: #fff;
    display: flex;
    font-size: 18px;
    padding: 0 20px;
    position: relative;
    text-transform: initial;
    z-index: 1;
  }
  .aside-item:hover {
    border: none;
    color: #fff;
  }
}
@media screen and (max-width: 600px) {
  .news-container {
    height: 150vw;
    margin: 0;
    width: 100%;
  }
  .news-main::before {
    font-size: 22px;
    height: 40px;
    left: -20px;
    width: 40px;
  }
  .news-footer {
    padding: 15px;
  }
  .news-footer span {
    font-size: 10px;
    margin-bottom: 0;
  }
  .news-footer h6 {
    font-size: 14px;
  }
  .news-all-item {
    height: 35vw;
  }
  .news-all-item-img {
    background-position: center;
  }
  .news-all-item-texts {
    padding: 10px 15px;
  }
  .news-all-item-title {
    font-size: 14px;
    width: 100%;
  }
  .news-all-item-date {
    font-size: 11px;
  }
  .news-all-item-content {
    display: none;
  }
  .category-title {
    font-size: 22px;
  }
  .aside-mobile-main-item,
  .aside-item {
    font-size: 16px;
  }
  .aside-li:first-of-type .aside-item {
    padding-right: 50px;
  }
}
@media screen and (max-width: 440px) {
  .category-title {
    font-size: 20px;
  }
  .aside {
    left: 30px;
    width: calc(100% - 60px);
  }
  .news-mobile-main-item,
  .aside-item {
    font-size: 13px;
  }
}
@media screen and (max-width: 380px) {
  .news-mobile-main-item,
  .aside-item {
    font-size: 12px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/News.vue